<div class="subscription-wrapper">
    <div class="container-header-subscription">
      <table class="content-table">
        <thead class="content-table-thead">
          <tr>
            <th class="content-table-thead">{{ 'SUBSCRIPTION_PAYMENT.DATE' | translate }}</th>
            <th class="content-table-thead">
              {{ 'SUBSCRIPTION_PAYMENT.TAXES' | translate }}
              <div *ngIf="taxDistributionSource === taxDistributionEnm.EMPLOYEE && !isMobile" class="subtitle pl-0">
                {{ 'SUBSCRIPTION_PAYMENT.WITHHELD_FROM_BUDGET' | translate }}
              </div>
              <div *ngIf="taxDistributionSource === taxDistributionEnm.EMPLOYEE_SALARY && !isMobile" class="subtitle pl-0">
                {{ 'SUBSCRIPTION_PAYMENT.WITHHELD_FROM_SALARY' | translate }}
              </div>
              <div *ngIf="taxDistributionSource === taxDistributionEnm.COMPANY && !isMobile" class="subtitle pl-0">
                {{ 'SUBSCRIPTION_PAYMENT.COVERED_COMPLETELY_BY_COMPANY' | translate }}
              </div>
            </th>
            <th class="content-table-thead">{{ 'SUBSCRIPTION_PAYMENT.PAYMENT' | translate }}</th>
            <th class="content-table-thead"></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let payment of payments">
            <ng-container *ngIf="payment.taxAmount !== payment.paymentAmount">
              <tr *ngIf="payment.isOverThreshold">
                <td colspan="6" class="bg-light text-left threshold-exceeded-message">
                  <div class="d-flex align-items-start">
                    <svg width="30px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 mr-1">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
                    </svg>
                    {{ (fitnessBenefit ? 'SUBSCRIPTION_PAYMENT.ANNUAL_THRESHOLD_EXEEDED_MESSAGE_FITNESS' : 'SUBSCRIPTION_PAYMENT.ANNUAL_THRESHOLD_EXEEDED_MESSAGE') | translate }}
                  </div>
                </td>
              </tr>
              <tr>
                <td class="paymentDate">
                  <ng-container *ngIf="!isMobile; else calendarIcon">
                    {{ payment.date | date:'mediumDate' }}
                  </ng-container>
                  <ng-template #calendarIcon>
                    <div style="color: #4981eb; max-width: 50px;" ngbTooltip="{{ payment.date | date:'mediumDate' }}" role="button"
                    tabindex="0" >
                      <i data-feather="calendar"></i>
                    </div>
                  </ng-template>
                </td>
                <td>
                  <div *ngIf="payment.taxesValue !== 0">
                    <div *ngIf="payment.taxAmount !== payment.paymentAmount && showTaxesForCompany">
                      {{ payment.taxesValue }}
                      <span class="ron">RON</span>
                    </div>
                    <div *ngIf="payment.taxAmount !== payment.paymentAmount && !showTaxesForCompany">-</div>
                  </div>
                </td>
                <td class="payment">
                  <div *ngIf="payment.taxAmount !== payment.paymentAmount && showTaxesForCompany" [ngClass]="{'payment-isPayed': payment.isPayed}">
                    {{ payment.paymentTotal.toFixed(2) }}
                    <span class="ron">RON</span>
                  </div>
                </td>
                <td>
                  <div *ngIf="payment.isPayed; else canNotFulfill" class="checkmark">
                    &#10003;
                  </div>
                  <ng-template #canNotFulfill>
                    <div *ngIf="payment.canBeFulfilled === false"
                         ngbTooltip="{{ 'SUBSCRIPTION_PAYMENT.PAYMENT_CAN_NOT_BE_FULFILLED' | translate : { monthlyBudget: monthlyBudget, month: payment.date | date:'MMMM' | uppercase | translate, year: payment.date | date:'yyyy', subscriptionAmount: payment.paymentTotal } }}"
                         class="xmark"
                         role="button"
                         tabindex="0">
                      <span data-feather="alert-circle" [size]="20"></span>
                    </div>
                  </ng-template>
                </td>
              </tr>
            </ng-container>
            <tr *ngIf="payment.taxAmount === payment.paymentAmount">
              <td class="paymentDate">
                <ng-container *ngIf="!isMobile; else calendarIcon">
                  {{ payment.date | date:'mediumDate' }}
                </ng-container>
                <ng-template #calendarIcon>
                  <div style="color: #4981eb; max-width: 50px;" ngbTooltip="{{ payment.date | date:'mediumDate' }} " role="button"
                  tabindex="0">
                    <i data-feather="calendar"></i>
                  </div>
                </ng-template>
              </td>
              <td>
                <div *ngIf="payment.taxesValue === 0 || !showTaxesForCompany">-</div>
                <div *ngIf="payment.taxesValue !== 0  && showTaxesForCompany">
                  {{ payment.taxesValue }}
                  <span class="ron">RON</span>
                </div>
              </td>
              <td class="payment">
                <div *ngIf="payment.isPayed" class="payment-isPayed">
                  {{ payment.paymentTotal.toFixed(2) }}
                  <span class="ron payment-isPayed">RON</span>
                </div>
                <div *ngIf="!payment.isPayed">
                  {{ payment.paymentTotal.toFixed(2) }}
                  <span class="ron">RON</span>
                </div>
              </td>
              <td>
                <div *ngIf="payment.isPayed===true; else canNotFulfill" class="checkmark">
                  &#10003;
                </div>
                <ng-template #canNotFulfill>
                  <div *ngIf="payment.canBeFulfilled === false"
                           ngbTooltip="{{ 'SUBSCRIPTION_PAYMENT.PAYMENT_CAN_NOT_BE_FULFILLED' | translate : { monthlyBudget: this.monthlyBudget, month: payment.date | date:'MMMM' | uppercase | translate, year: payment.date | date:'yyyy', subscriptionAmount: payment.paymentTotal} }}"
                           class="xmark">
                          <span data-feather="alert-circle" [size]="20"></span>
                      </div>
              </ng-template>
              </td>
            </tr>
          </ng-container>
        </tbody>
        <tfoot>
          <tr>
            <td class="total-payment">{{ 'SUBSCRIPTION_PAYMENT.TOTAL' | translate }}</td>
            <td class="total-payment table-paymentValue">
              <div *ngIf="!showTaxesForCompany">-</div>
              <div *ngIf="showTaxesForCompany">
              {{ this.taxesValueTotal.toFixed(2) }}<span class="ron">RON</span>
              </div>

            </td>
            <td class="total-payment payment">
              {{ this.paymentTotal.toFixed(2) }}
              <span class="ron">RON</span>
            </td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
